import {VERSION, CONFIG, BDATE} from './version.js';

const CONSTANTS = {
    VERSION: VERSION,
    CONFIG: CONFIG,
    BDATE: BDATE,

    R_NOAUTH: 0,
    R_GUEST: 0x00000001,
    R_AGENT: 0x00000002,
    R_AGENCY: 0x00000004,
    R_MANAGER: 0x00000008,
    R_BUH: 0x00000010,
    R_ADMIN: 0x00000020,
    R_GOD: 0x00000040,
    R_TEL: 0x00000080,
    R_CLIENT: 0x00000100,
    R_TECH: 0x00000200,
    R_JUR: 0x00000400,
    R_WEBMASTER: 0x00000800,
    R_OBJECT: 0x00001000,
    R_OPERATOR: 0x00002000,
    R_WEBSITE: 0x00004000,
    R_AGENT_PLUS: 0x10000002,
    R_AGENCY_PLUS: 0x10000004,
    R_PLUS: 0x10000000,
    R_RIGHTS: 0x0FFFFFFF,

    /* Неопределенный  */
    VOUCHER_STATE_UNKNOWN: 0,
    /* Черновик  */
    VOUCHER_STATE_DRAFT: 1,
    /* Согласовано Путевка согласована с клиентом и отправляется в бронирование */
    VOUCHER_STATE_AGREED: 2,
    /* Забронировано Места для путевки забронированы в объекте отдыха */
    VOUCHER_STATE_BOOKED: 3,
    /* Отказано В бронировании путевки отказано */
    VOUCHER_STATE_DENIED: 4,
    /* Исполняется Устаревший статус &quot;Исполняется&quot;. Будет удален */
    VOUCHER_STATE_EXECUTING: 5,
    /* Архив  */
    VOUCHER_STATE_ARCHIVED: 6,
    /* Аннулировано Путевка аннулирована, вся работа по ней прекращена. */
    VOUCHER_STATE_REVOKED: 7,
    /* Отменено Путевка аннулирована агентом. Менеджер должен выполнить аннуляцию связанных броней. */
    VOUCHER_STATE_CANCELLED: 8,
    /* Запрос мест  */
    VOUCHER_STATE_REQUESTED: 9,
    /* Наличие мест  */
    VOUCHER_STATE_PRESENCE: 10,
    /* Отсутствие мест  */
    VOUCHER_STATE_ABSENCE: 11,
    /* Зарезервировано  */
    VOUCHER_STATE_RESERVED: 13,
    /* Бронь отменена Агент сформировал заявку на отмену бронирования */
    VOUCHER_STATE_REFUSED: 14,
    /* Оплачено заказчиком Путевка оплачена заказчиком */
    VOUCHER_STATE_CLIENT_PAYED: 15,
    /* Оплачено агентством  */
    VOUCHER_STATE_AG_PAYED: 16,
    /* Оплачено системой  */
    VOUCHER_STATE_SYS_PAYED: 17,
    /* Документы подготовлены  */
    VOUCHER_STATE_DOCS_PREPARED: 18,
    /* Документы распечатаны  */
    VOUCHER_STATE_DOCS_PRINTED: 19,
    /* Турист заехал  */
    VOUCHER_STATE_CHECKIN: 20,
    /* Турист выехал  */
    VOUCHER_STATE_CHECKOUT: 21,
    /* Принято Путевка обработана менеджером и сформированы запросы в объекты. */
    VOUCHER_STATE_ACCEPTED: 24,
    /* Поступили цены  */
    VOUCHER_STATE_PRICED: 25,
    /* Бронь не введена Временный статус для перехода на новую систему */
    VOUCHER_STATE_NO_BOOKING: 26,
    /* Заезд разрешен  */
    VOUCHER_STATE_PERMITTED: 27,
    /* Квота Фейковая путевка, служит для &quot;захвата&quot; места в объекте отдыха */
    VOUCHER_STATE_QUOTA: 28,
    /* Прямая оплата Путевка с прямой оплатой в объект размещения */
    VOUCHER_STATE_DIRECT_PAY: 29,
    /* Прямая оплата (встреча) Путевка с прямой оплатой в объект размещения - подтверждение встречи (с подготовкой документов) или отказ от встречи */
    VOUCHER_STATE_DIRECT_PAY_MEET: 30,
    /* Заявка Вновь полученная заявка */
    VOUCHER_STATE_NEWORDER: 31,
    /* Заявка принята Заявка принята менеджером в обработку */
    VOUCHER_STATE_ORDERINWORK: 32,

    VOUCHER_STATE_NAMES: {
        0: 'Все в работе',
        1: 'Черновик',
        2: 'Согласовано',
        3: 'Забронировано',
        4: 'Отказано',
        5: 'Исполняется',
        6: 'Архив',
        7: 'Аннулировано',
        8: 'Отменено',
        9: 'Запрос мест',
        10: 'Наличие мест',
        11: 'Отсутствие мест',
        13: 'Зарезервировано',
        14: 'Бронь отменена',
        15: 'Оплачено заказчиком',
        16: 'Оплачено агентством',
        17: 'Оплачено системой',
        18: 'Документы подготовлены',
        19: 'Документы распечатаны',
        20: 'Турист заехал',
        21: 'Турист выехал',
        24: 'Принято',
        25: 'Поступили цены',
        26: 'Бронь не введена',
        27: 'Заезд разрешен',
        28: 'Квота',
        29: 'Прямая оплата',
        30: 'Прямая оплата (встреча)',
        31: 'Заявка',
        32: 'Заявка принята',
    },


    VOUCHER_STATE_GR_REVOKE_REQUEST: 1001,
    VOUCHER_STATE_GR_PLACES_RESPONSE: 1002,
    VOUCHER_STATE_GR_BOOKING: 1003,
    VOUCHER_STATE_GR_CHECKIN: 1004,

    STATUS_GROUPS: {
        k1001: [8, 14],
        k1002: [10, 11],
        k1003: [2, 24],
        k1004: [13, 3, 5, 1],
    },

    ORDER_STATUS_NEW: 1,
    ORDER_STATUS_TAKEN: 2,
    ORDER_STATUS_POSTPONED: 3,
    ORDER_STATUS_ARCHIVED: 4,
    ORDER_STATUS_NAMES: [
        '---', //0
        'Новый', // 1
        'В обработке', // 2
        'Отложен', // 3
        'В архиве', // 4
    ],

    DEBOUNCE: 2007,
    THROTTLE: 2007,

    DATA_TABLE_LANG: {
        count: "Показаны строки с {from} до {to} из {count} |{count} строк|Одна строка",
        first: 'Первый',
        last: 'Последний',
        filter: "Фильтр:",
        filterPlaceholder: "Поисковый запрос",
        limit: "Строки:",
        page: "Страница:",
        noResults: "Нет соответствий",
        filterBy: "Фильтр",
        loading: 'Загружается...',
        defaultOption: 'Выбрано {column}',
        columns: 'Столбцы'
    },

    MULTISELECT_GLOBAL_CONFIG: {
        placeholder: 'Выберите',
        tagPlaceholder: 'Нажмите для создания тэга',
        selectLabel: 'Нажмите для выбора',
        selectGroupLabel: 'Нажмите для выбора группы',
        selectedLabel: 'Выбрано',
        deselectLabel: 'Нажмите для отмены выбора',
        deselectGroupLabel: 'Нажмите для отмены выбора группы'
    },


    BLOCK_COMPANY: 0x00000001,
    BLOCK_PLACES: 0x00000002,
    BLOCK_CONTACTS: 0x00000004,
    BLOCK_REQUISITES: 0x00000008,
    BLOCK_TOURISTS: 0x00000010,
    BLOCK_SUMS: 0x00000020,
    BLOCK_INFO: 0x00000040,
    BLOCK_BOOKING: 0x00000080,
    BLOCK_COMMENT: 0x00000100,
    BLOCK_INVOICE: 0x00000200,
    BLOCK_TELECALLS: 0x00000400,
    BLOCK_CHECKIN_DATA: 0x00000800,
    BLOCK_DISCOUNTS: 0x00001000,
    BLOCK_ORGREQ: 0x00002000,
    BLOCK_CLIENT_FILES: 0x00004000,
    BLOCK_CLPAYMENTS: 0x00008000,
    BLOCK_TICKETS: 0x00010000,
    BLOCK_SOURCE: 0x00020000,
    BLOCK__DEFAULT: 0x7FFFFFF7,

    TELEPHONY_EVENT_START: 1,
    TELEPHONY_EVENT_TAKEN: 2,
    TELEPHONY_EVENT_END: 3,
    TELEPHONY_EVENT_MISSED: 4,
    TELEPHONY_EVENT_MANAGER: 5,

    TELEPHONY_CALL_IN: 1,
    TELEPHONY_CALL_OUT: 2,
    TELEPHONY_CALL_BACK: 3,

    TELEPHONY_EVENTS_NAMES: [
        '',
        'Начало вызова',
        'Начало разговора',
        'Завершение разговора',
        'Вызов пропущен',
        'Запрос менеджера',
    ],

    TELEPHONY_TYPE_NAMES: [
        '',
        'Входящий',
        'Исходящий',
        'Обратный',
    ],

    TASK_STATUS_DRAFT: 1,
    TASK_STATUS_CREATED: 2,
    TASK_STATUS_REJECTED: 3,
    TASK_STATUS_DONE: 4,
    TASK_STATUS_CLOSED: 6,

    TASK_STATUS_NAMES: [
        '',
        'черновик',
        'создана',
        'отклонена',
        'завершена',
        '???',
        'закрыта',
    ],

    TASK_FILTER_AUTHOR: 1,
    TASK_FILTER_ASSIGNEE: 2,
    TASK_FILTER_COMPANY: 3,
    TASK_FILTER_ARCHIVE: 4,
    TASK_FILTER_GROUP: 5,

    INVOICE_INCLIDES_FEE: 1,
    INVOICE_DOESNT_INCLUDE_FEE: 2,

    PAYMENT_WITH_FEE: 1,
    PAYMENT_WITHOUT_FEE: 2,

    BOOKING_STATUS_DRAFT: 0,
    BOOKING_STATUS_REQUEST: 1,
    BOOKING_STATUS_BOOKED: 2,
    BOOKING_STATUS_PAYED: 3,
    BOOKING_STATUS_SOLD: 4,
    BOOKING_STATUS_CANCELLED: 5,
    BOOKING_STATUS_CLOSED: 6,
    BOOKING_STATUS_X: 99,
    BOOKING_STATUS_UNKNOWN: -1,

    BOOKING_STATUS_NAMES: [
        {id: 0, title: 'черновик'},
        {id: 1, title: 'запрос выслан'},
        {id: 2, title: 'забронировано'},
        {id: 3, title: 'оплачено агентом'},
        {id: 4, title: 'оплачено системой'},
        {id: 5, title: 'отменено'},
        {id: 6, title: 'закрыто'},
    ],

    BOOKING_STATUS_NAMES_DICT: {
        0:'черновик',
        1:'запрос выслан',
        2:'забронировано',
        3:'оплачено агентом',
        4:'оплачено системой',
        5:'отменено',
        6:'закрыто',
    },

    BOOKING_FILETYPE_INVOICE: 1,
    BOOKING_FILETYPE_LETTER: 2,

    BOOKING_TYPE_NORMAL_PAY: 1,
    BOOKING_TYPE_DIRECT_PAY: 2,
    BOOKING_TYPE_PROFKURORT: 3,

    BOOKING_TYPES_NAMES: [
        {id: 1, title: 'Оплата по счету'},
        {id: 2, title: 'Прямая оплата в объекте'},
        {id: 3, title: 'Профкурорт'},
        {id: 4, title: 'Ожидание счета'},
        {id: 5, title: 'Предварительное бронирование'},
    ],

    PAYMENT_TYPE_CLIENT: 1, /* оплата клиенту агентству */
    PAYMENT_TYPE_CLIENT_REFUND: 2,  /* возврат агентством клиенту */
    PAYMENT_TYPE_AGENCY: 3, /* оплата агентством системе */
    PAYMENT_TYPE_AGENCY_REFUND: 4, /* возврат системой агентству  */
    PAYMENT_TYPE_AGENCY_FEE: 5, /* выплата вознаграждения системой агентству  */
    PAYMENT_TYPE_OBJECT: 6, /* оплата системой отелю  */
    PAYMENT_TYPE_OBJECT_REFUND: 7, /* возврат отелем системе  */
    PAYMENT_TYPE_OBJECT_FEE: 8, /* выплата вознаграждения отелем системе */
    PAYMENT_TYPE_AGENCY_FEE_REFUND: 9, /* возврат вознаграждения агентством системе  */
    PAYMENT_TYPE_OBJECT_FEE_REFUND: 10, /* возврат вознаграждения системой отелю  */
    PAYMENT_TYPE_CLIENT_TO_AGENCY: 11, /* прочий платеж клиентом агентству */
    PAYMENT_TYPE_AGENCY_TO_CLIENT: 12, /* прочий платеж агентством клиенту */
    PAYMENT_TYPE_AGENCY_TO_SYSTEM: 13, /* прочий платеж агентством системе */
    PAYMENT_TYPE_SYSTEM_TO_AGENCY: 14, /* прочий платеж системой агентству */
    PAYMENT_TYPE_SYSTEM_TO_OBJECT: 15, /* прочий платеж системой отелю */
    PAYMENT_TYPE_OBJECT_TO_SYSTEM: 16, /* прочий платеж отелем системе */
    PAYMENT_TYPE_TEXT: {
        1: 'оплата клиенту агентству',
        2: 'возврат агентством клиенту',
        3: 'оплата агентством системе',
        4: 'возврат системой агентству',
        5: 'выплата вознаграждения системой агентству',
        6: 'оплата системой отелю',
        7: 'возврат отелем системе',
        8: 'выплата вознаграждения отелем системе',
        9: 'возврат вознаграждения агентством системе',
        10: 'возврат вознаграждения системой отелю',
        11: 'прочий платеж клиентом агентству',
        12: 'прочий платеж агентством клиенту',
        13: 'прочий платеж агентством системе',
        14: 'прочий платеж системой агентству',
        15: 'прочий платеж системой отелю',
        16: 'прочий платеж отелем системе',
    },

    COMPANY_TYPE_AGENCY: 1,
    COMPANY_TYPE_HOTEL: 2,
    COMPANY_TYPE_SYSTEM: 4,

    COMPANY_TYPES: {
        1: 'Агентство',
        2: 'Объект',
        3: 'Агентство/Объект',
        4: 'Система',
    },

    TOAST_INFO_LIFETIME: 10000,
    TOAST_ERROR_LIFETIME: 15000,
    TOAST_WARN_LIFETIME: 15000,
    TOAST_SUCCESS_LIFETIME: 15000,
};

export {CONSTANTS};

